<template>
  
  <div class="sectForm">
    <ul class="sub">
      <div>
        <li v-for="dossier in dossiers" :key="dossier.nom">
          
          <div class="dossier" v-if="dossier.type === 'dossier'">
            <div class="dossier-header">
              
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-fill" viewBox="0 0 16 16">
                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
              </svg>
              <input class="checkbox-header" type="checkbox" :value="dossier" v-model="selectAll" @change="handleSelectionChange(dossier)" />
              <span  @click="toggleDossier(dossier)">{{ dossier.nom }}</span>
      
  
              
            </div>
            <ul v-if="dossier.isExpanded && !dossier.sousDossiers.length == 0 ">
              <nested-list :dossiers="dossier.sousDossiers" @ajouter-element="mettreAJourEnfant" @ajouter-fichiers="mettreAJourEnfant2" @selection-change="handleSelectionChangeEnfant"></nested-list>
              <button class="add-button" @click="openPopup(dossier.chemin)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>
              </svg>Ajouter</button>
            </ul>
            <div v-if="dossier.sousDossiers.length === 0 && dossier.isExpanded" class="no-sub-dossiers">
              <div>Aucun documents disponible.</div>
              <button class="add-button" @click="openPopup(dossier.chemin)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>
              </svg>Ajouter</button>
            </div>
  
  
          </div>
          <div v-else>
            <div class="linkFile">
              
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-fill" viewBox="0 0 16 16">
              <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z"/>
              </svg>
              <input class="checkBox" type="checkbox" :value="dossier" @change="handleSelectionChange(dossier)"
              />
              <span><a href="#" @click="telechargerFichier(dossier.chemin, dossier.nom)">{{ dossier.nom }}</a></span>
            </div>
            
          </div>
        </li>
      </div>
      
    </ul>
  </div>






  <div v-if="popupOpen" class="popup popup-folders" @click="closePopup">
    <!-- Popup content -->
    <div class="popup-content" @click.stop>
      <!-- Popup header -->
      <div class="popup-header">
        <h2>Ajouter des documents</h2>
        <a class="close-button" @click="closePopup">&times;</a>
      </div>
  
      <!-- Popup body -->
      <div class="popup-body">
       
        <div v-if="confirmationMessage" class="alert alert-success" role="alert">
          {{ confirmationMessage }}
        </div>
        <div v-if="errorMessage" class="alert alert-danger" role="alert">
          {{ errorMessage }}
        </div>
        <form @submit.prevent="ajouterElement(dossier)">

          <div>
            <label for="typeDoc">Type de document</label>
            <select id="typeDoc" v-model="typeDoc" required>
              <option value="dossier">Dossier</option>
              <option value="fichier">Fichier</option>
            </select>
          </div>
          
          <!-- Afficher le champ "Fichier" si le type de dossier est "fichier" -->
          <div v-if="typeDoc === 'fichier'">
            <input id="file" type="file" multiple @change="addFichiers" accept="image/*,.pdf,.igs,.prt,.vcf,.step,.stp" capture required>
            <label for="file"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
            </svg>Choisir un ou plusieurs fichier(s)</label>
          </div>
          
          <!-- Afficher le champ "Nom du dossier" si le type de dossier est "dossier" -->
          <div v-else>
            <input type="text" id="nomFichier" v-model="nomFichier" placeholder="Nom du dossier">
          </div>
          <button v-if="typeDoc === 'fichier'" type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
          <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
          </svg>Envoyer le/les fichier(s)</button>
          <button v-else type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
          <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
          </svg>Créer le dossier</button>
        </form>
      </div>
    </div>
  </div>
   <!-- Loader -->
   <div v-if="isLoading" class="loader">
    <div id="loading"></div>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js';

export default {
  name: 'NestedList',
  props: {
    dossiers: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      isExpanded: false,
      popupOpen: false,
      typeDoc: 'dossier',
      nomFichier:'',
      fichiers: [],
      selectedDocuments: [],
      url:'',
      userName:'',
      isLoading: false,
      dossiersCopy: [],
      selectedItems: [], 

    }
  },
  created() {
    this.userName = (this.$route.params.nom + '-' + this.$route.params.prenom).toLowerCase();    
  },
  methods: {
    toggleDossier(dossier) {
      dossier.isExpanded = !dossier.isExpanded;
    },
  
    handleSelectionChange(dossier) {
      this.$emit('selection-change', dossier); // Émettez un événement personnalisé
    },
    addFichiers(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
          this.fichiers.push(files[i]);
      }
    },
    openPopup(url) {
      this.popupOpen = true;
      this.url = url;
    },

    closePopup(event) {
      event.stopPropagation();
      this.popupOpen = false;
    },
    ajouterElement() {
      this.isLoading = true; // Show loader
      // Create a new FormData object
      const formData = new FormData();

      // Ajouter les fichiers au formulaire
      for (let i = 0; i < this.fichiers.length; i++) {
          formData.append('fichiers[]', this.fichiers[i]);
      }
      // Add the user and chantier information to the form data
      formData.append('chemin', this.url);
      formData.append('typeDoc', this.typeDoc);
      formData.append('nomFichier', this.nomFichier);
      console.log(this.fichiers);

      // Make the API request
      axios.post('https://www.simef.fr/espace-client/api/addElementEspace.php', formData)
      .then(response => {
          // Handle the response from the server
          console.log(response);
          if (response.data.success) {
            if (this.typeDoc === 'dossier') {
              let nouveauElement = {
                nom: this.nomFichier,
                type: this.typeDoc,
                chemin: this.url + '/' + this.nomFichier,
                sousDossiers: []
                // Ajoutez d'autres attributs nécessaires pour votre objet élément ici
              };
              let cheminDuDossierAModifier = this.url;
              
              this.$emit('ajouter-element', nouveauElement, cheminDuDossierAModifier);

            } else {
              // Handle adding multiple files
              const nouveauxFichiers = this.fichiers.map(file => ({
                nom: file.name,
                type: 'fichier',
                chemin: this.url + '/' + file.name,
                sousDossiers: []
                // Add other necessary attributes for your file object here
              }));

              let cheminDuDossierAModifier = this.url;

              this.$emit('ajouter-fichiers', nouveauxFichiers, cheminDuDossierAModifier);
            }

          }
          
          this.confirmationMessage = response.data.success;
          this.errorMessage = response.data.error;
          this.fichiers = [];
          this.nomFichier = '';

      
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      })
      .finally(() => {
        this.isLoading = false; // Hide loader
      });
    },
    telechargerFichier(url, nomFichier) {
      const motARemplacer = '/simef';
      const urlModifiee = url.replace(motARemplacer, 'https://www.simef.fr');
      console.log(url);

      fetch(urlModifiee)
        .then(response => response.blob())
        .then(blob => {
          const urlBlob = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = urlBlob;
          a.download = nomFichier;
          a.click();
          window.URL.revokeObjectURL(urlBlob);
        })
        .catch(error => {
          console.error(error);
        });

        window.open(urlModifiee, '_blank');
    },
    mettreAJourEnfant(nouveauElement, cheminDuDossierAModifier) {
      console.log('mettreAJourEnfant est appelé');
      this.rechercherEtAjouterElement(this.dossiers, nouveauElement, cheminDuDossierAModifier);
    },
    mettreAJourEnfant2(nouveauxFichiers, cheminDuDossierAModifier) {
      console.log('mettreAJourEnfant2 est appelé');
      this.rechercherEtAjouterElement2(this.dossiers, nouveauxFichiers, cheminDuDossierAModifier);
    },
    rechercherEtAjouterElement(dossiers, nouveauElement, cheminDuDossierAModifier) {
      for (let i = 0; i < dossiers.length; i++) {
        const dossier = dossiers[i];
        if (dossier.chemin === cheminDuDossierAModifier) {
          if (nouveauElement.type === 'dossier') {
            dossier.sousDossiers.push(nouveauElement);
          } else {
            dossiers.push(nouveauElement);
          }
          return;
        }
        if (dossier.sousDossiers.length > 0) {
          this.rechercherEtAjouterElement(dossier.sousDossiers, nouveauElement, cheminDuDossierAModifier);
        }
      }
    },
    rechercherEtAjouterElement2(dossiers, nouveauxFichiers, cheminDuDossierAModifier) {
      for (let i = 0; i < dossiers.length; i++) {
        const dossier = dossiers[i];
        if (dossier.chemin === cheminDuDossierAModifier) {
            for (let i = 0; i < nouveauxFichiers.length; i++) {
              if (nouveauxFichiers[i].type === 'fichier') {
                dossier.sousDossiers.push(nouveauxFichiers[i]);
              } else {
                dossiers.push(nouveauxFichiers[i]);
              }
            }
          return;
        
        }
        if (dossier.sousDossiers.length > 0) {
          this.rechercherEtAjouterElement2(dossier.sousDossiers, nouveauxFichiers, cheminDuDossierAModifier);
        }
      }
    },
    handleSelectionChangeEnfant(dossier) {
      console.log('handled2');
      this.$emit('selection-change', dossier); // Émettez un événement personnalisé

    }
   
  }
}
</script>

<style lang="scss" scoped>
.checkBox {
  margin-right: 5px;
}
.checkbox-header {
  margin-right: 5px;
}
.popup-folders {
  form {
    select#typeDoc {
      margin-bottom: 10px;
    }
  }
}
.popup form {
  background: none!important;
  padding: 0px!important;
}
.sectForm {
  margin-bottom: 0px;
  ul {
    margin: 0px!important;
    li {
      font-weight: 500;
    }
  }
}
.sub {
  list-style: none;
  padding: 0;
  text-align: left;
  
  button.add-button {
      background: none!important;
      padding: 0!important;
      color: #2b358d !important;
      font-size: 0.8rem;
      margin-top: 0px!important;
      display: flex;
      align-items: center;
      svg {
        margin-right: 5px!important;
        height: 13px;
        width: 13px;
      }
  }
  .linkFile {
    svg {
      path {
        fill: #2b358d !important;
      }
    }
    a {
      color: #2b358d !important;
      font-size: 0.9rem;
      text-decoration: none;
    }
  }
 
}
.checkDossiers {
  list-style: none;
  padding: 0;
  
}
.subfolders {
    display: flex;
    flex-direction: row;
    align-items: center;

    input {
      width: inherit!important;
      margin-bottom: 0px!important;
    }

}

.check {
  display: flex;
  align-items: center;

  input[type="checkbox"] {
    width: inherit!important;
  }
}

.dossier {
  margin-bottom: 5px;
}

.dossier-header {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dossier-header svg {
  margin-right: 5px;
}

.file {
  margin-left: 20px;
}
.no-sub-dossiers {
  font-size: 0.8rem;
  padding-left: 25px;
}
.dossier-header, span {
  font-size: 0.9rem;
}
li {
  svg {
    margin-right: 5px;
  }
}


.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.popup-content {
  max-width: 850px;
  max-height: 90%;
  background-color: #fff;
  padding: 40px 60px;
  border-radius: 0px;
  @media screen and (max-width:992px) {
    max-width: 90%;
    max-height: 90%;
  }

}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  h3 {
    margin: 0px;
  }
}

.close-button {
  background: none;
  border: none;
  font-size: 30px;
  cursor: pointer;
  padding: 3px 7px!important;
  top: 4%;
  font-size: 1.5rem;
  transform: translateX(-100%);
  left: 98%;
  margin: 0px !important;
  color: #2b358d;
  line-height: 1!important;
}
</style>